"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Badge: function() {
        return _index.Badge;
    },
    badgeClassNames: function() {
        return _index.badgeClassNames;
    },
    renderBadge_unstable: function() {
        return _index.renderBadge_unstable;
    },
    useBadgeStyles_unstable: function() {
        return _index.useBadgeStyles_unstable;
    },
    useBadge_unstable: function() {
        return _index.useBadge_unstable;
    }
});
const _index = require("./components/Badge/index");
